import { createSlice } from "@reduxjs/toolkit";
import { resetPasswordAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: data,
  reducers: {
    resetPasswordSlice(state) {
      state.isLoading = true;
    },
    resetPasswordSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    resetPasswordSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload;
    },
    resetPasswordSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const resetPasswordHandler = (data: any) => async (dispatch: any) => {
  try {
    dispatch(resetPasswordAction.resetPasswordSlice());
    const response: any = await resetPasswordAPI(data);
    showSuccessToast(response?.message)
    dispatch(resetPasswordAction.resetPasswordSliceSuccess(response));
  } catch (e: any) {
    showErrorToast(e?.response?.data?.error_message)
    dispatch(resetPasswordAction.resetPasswordSliceFailure(e?.response?.data));
  }
};
export default resetPasswordSlice.reducer;
export const resetPasswordAction = resetPasswordSlice.actions;
